import { Component, Input } from '@angular/core';

@Component({
    selector: 'info-icon',
    templateUrl: './info-icon.component.html',
    styleUrls: ['./info-icon.component.scss'],
    standalone: false
})
export class InfoIconComponent  {

  @Input() info:string;
  constructor() { }

}
